jQuery(document).ready(function ($) {
  // escape hatch
  if (!$("iframe.videoask").length) return;

  // VideoAsk - get contact_name from URL param and append to iframe
  var video_ask_src = $("iframe.videoask").attr("src");

  if ($("body").data("user")) {
    contact_name = $("body").data("user");
    var new_video_ask_src = video_ask_src + "?contact_name=" + contact_name;
    $("iframe.videoask").attr("src", new_video_ask_src);
  }
});
